export default __webpack_public_path__ + "static/media/78-min.f05fe673.jpg";